export default "__VITE_ASSET__lXX5Cg71__"